import { MapMarkerStarOutlineIcon } from './MapMarkerStarOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9B256D01-4CB0-4736-BBB7-6D44417DD02B
 * name map-marker-star-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-star-outline.svg
 * tags
 * - Navigation 
 */
export const LocationFavoriteOutlineIcon = MapMarkerStarOutlineIcon;
export default LocationFavoriteOutlineIcon